<template>
<div class="modal fade" id="modal-create-template">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title">Create email template for bunch of products</h4>
      </div>
      <div class="modal-body form-horizontal">

        <div class="form-group" style="margin: 0 0 20px 0;">
          <label for="product" class="form-control-label">Search product by name</label>

          <v-select
            :key="key"
            id="product"
            v-model="product"
            :options="options"
            :class="['form-control-select2']"
            label="name"
            @search="loadProducts"
            @input="addProduct"
          ></v-select>
        </div>

        <table class="table table-striped table-hover" v-if="products.length">
          <thead>
            <tr>
              <th style="width: 100px;">Photo</th>
              <th>Product name</th>
              <th style="width: 50px;"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="product in products" :key="product.id">
              <td>
                <img :src="imagePath(product.images)" :alt="product.name" width="75">
              </td>
              <td>{{ product.name }}</td>
              <td>
                <button type="button" class="btn btn-default" @click="removeProduct(product)">X</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default pull-left" data-dismiss="modal">{{$t('close')}}</button>
        <button type="button" class="btn btn-success pull-left" @click="createTemplate">Create template</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {mapActions} from 'vuex'
import axios from '../../interceptor'

export default {
  name: 'ModalCreateTemplate',
  data () {
    return {
      products: [],
      product: null,
      key: 0
    }
  },
  computed: {
    options () {
      return this.$store.getters['product/list/items']
    }
  },
  methods: {
    ...mapActions({
      getProducts: 'product/list/default',
    }),
    imagePath (images) {
      if (images.length) {
        return process.env.API_URL + '/images/200/' + images[0].contentUrl
      }
    },
    addProduct(product) {
      const exists = this.products.find(item => item.id === product.id)

      if (exists) {
        alert('This product already added')
      } else {
        this.products.push(product)
      }

      this.product = null
      this.key += 1
    },
    removeProduct(product) {
      if (confirm('Do you really want to remove product form email template?')) {
        this.products = this.products.filter(item => item.id !== product.id)
      }
    },
    loadProducts(keyword, loading) {
      loading(true);
      this.searchProducts(loading, keyword, this);
    },
    searchProducts: _.debounce((loading, keyword, vm) => {
      vm.getProducts('/products?name=' + keyword)
      loading(false);
    }, 350),
    createTemplate() {
      if  (confirm('Do you really want to create email template for Unisender?')) {
        axios.post(process.env.API_URL + '/products/template/many', this.products.map(item => item.id))
          .then(response => {
            // this.products = []
            this.$toastr.s('Email template successfully created')
          }).catch(() => {
            this.$toastr.e(this.$t('Unable to generate email template'))
          })
      }
    }
  }
}
</script>
